// src/state-management/peerAnalyserStore.ts
import { create } from 'zustand'
import { FundNature } from '../types/peer-analyser'

interface PeerAnalyserState {
  selectedCategoryId: string
  fundNature: FundNature
  isUserExhaustedPASubs: boolean
  isSubscribedToPeerAnalyser: boolean
  isUserElite: boolean
  isFtuxEnabled: boolean
  showEliteUnlockedModal: boolean
  showFilterBottomSheet: boolean
  tenureInDays: number
  throughFamilyAccess: boolean
  error: string | null
  setTenureInDays: (days: number) => void
  setSelectedCategoryId: (id: string) => void
  setFundNature: (nature: FundNature) => void
  setisUserExhaustedPASubs: (initialState: boolean) => void
  setisSubscribedToPeerAnalyser: (initialState: boolean) => void
  setisUserElite: (initialState: boolean) => void
  setIsFtuxEnabled: (enabled: boolean) => void
  setShowEliteUnlockedModal: (show: boolean) => void
  setShowFilterBottomSheet: (show: boolean) => void
  setThroughFamilyAccess: (throughFamilyAccess: boolean) => void
  setError: (error: string | null) => void
  clearError: () => void
}

export const usePeerAnalyserStore = create<PeerAnalyserState>((set) => ({
  selectedCategoryId: 'LARGE_CAP',
  fundNature: FundNature.EQUITY,
  isUserExhaustedPASubs: false,
  isSubscribedToPeerAnalyser: false,
  isUserElite: false,
  isFtuxEnabled: false,
  showEliteUnlockedModal: false,
  showFilterBottomSheet: false,
  throughFamilyAccess: false,
  error: null,
  tenureInDays: 0,
  setTenureInDays: (days: number) => set({ tenureInDays: days }),
  setSelectedCategoryId: (id) => set({ selectedCategoryId: id }),
  setFundNature: (nature) => set({ fundNature: nature }),
  setisUserExhaustedPASubs: (initialState) => set({ isUserExhaustedPASubs: initialState }),
  setisSubscribedToPeerAnalyser: (initialState) => set({ isSubscribedToPeerAnalyser: initialState }),
  setisUserElite: (initialState) => set({ isUserElite: initialState }),
  setIsFtuxEnabled: (enabled) => set({ isFtuxEnabled: enabled }),
  setShowEliteUnlockedModal: (show) => set({ showEliteUnlockedModal: show }),
  setShowFilterBottomSheet: (show) => set({ showFilterBottomSheet: show }),
  setThroughFamilyAccess: (throughFamilyAccess: boolean) => set({ throughFamilyAccess: throughFamilyAccess }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null })
}))
